export const GMS_ADMIN_SECTIONS = {
    teamMembers: "Team Members",
    manageApplications: "Manage Applications",
    manageDiscretionaryProjects: "Manage Discretionary Projects"
};